import { ActionType } from "../constants/existingCoords";

const initialState = {
  loading: false,
  existingCoords: [],
  previewCoords: [],
  markId: null, // The mark ID (e.g., 519) - used for updating
  submissionId: null, // The submission ID (e.g., 28) - for reference
  isPreview: false,
  // Which map existingCoords belong to, and whether a tag filter was applied
  loadedMapId: null,
  isTagFiltered: false,
  errors: {},
};

const coords = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_ALL_MAP_MARKS_START:
      return {
        ...state,
        loading: true,
        isPreview: false,
        loadedMapId: null,
      };
    case ActionType.GET_MARK_PREVIEW_START:
      return {
        ...state,
        loading: true,
        loadedMapId: null,
      };
    case ActionType.GET_ALL_MAP_MARKS_SUCCESS:
      return {
        ...state,
        loading: false,
        existingCoords: action.payload,
        loadedMapId: action.mapId,
        isTagFiltered: !!action.isTagFiltered,
      };
    case ActionType.GET_MARK_PREVIEW_SUCCESS:
      const { items, submission_id, mark_id } = action.payload;
      return {
        ...state,
        previewCoords: items,
        markId: mark_id, // Store mark_id for updates
        submissionId: submission_id,
        loading: false,
      };
    case ActionType.SET_MARK_PREVIEW:
      return {
        ...state,
        isPreview: action.payload,
      };
    case ActionType.GET_ALL_MAP_MARKS_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    case ActionType.GET_MARK_PREVIEW_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };
    default:
      return state;
  }
};

export default coords;
